import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

const updateOrderStatus = async ({ orderId, status }, token) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/${orderId}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const useUpdateOrderStatus = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ orderId, status }) => updateOrderStatus({ orderId, status }, token),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("myOrders");
        queryClient.invalidateQueries("merchantOrders");
        queryClient.invalidateQueries("allOrders");
      },
    }
  );
};

export default useUpdateOrderStatus;
